module.exports = __webpack_public_path__ + "static/media/area.de0f27b3.svg";